import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    issueNumber: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(2),
        fontSize: "14px",
        fontFamily: "Open Sans",
    },
    divider: {
        width: "100%",
    },
    content: {
        padding: `${theme.spacing(6)} ${theme.spacing(8)}`,
    },
    datePicker: {
        "& .MuiOutlinedInput-root": {
            height: "40px",
        },
    },
    keyPerformanceIndicatorLabel: {
        "&.MuiTypography-root": {
            fontFamily: "Open Sans",
            fontWeight: 700,
            fontSize: "12px",
            textTransform: "uppercase",
            color: theme.palette.primary.dark,
            maxWidth: "100% !important",
            whiteSpace: "normal",
        },
        "&.MuiFormLabel-root": {
            fontFamily: "Open Sans",
            fontWeight: 700,
            fontSize: "12px",
            textTransform: "uppercase",
            color: theme.palette.primary.dark,
        },
        "&.MuiFormLabel-root.Mui-focused": {
            color: theme.palette.primary.dark,
        },
    },
}));
